import { FC } from 'react';
import { AdvertServiceDataType } from '@edikk-edikk/country-frontend';
import advertDetailServiceCss from '../../assets/service/service.module.scss';

type PropsType = {
  price: AdvertServiceDataType['price'];
};

const ServicePrice: FC<PropsType> = ({
  price,
}) => {
  if (!price) {
    return null;
  }

  return (
    <span className={advertDetailServiceCss.advertDetailService__price}>
      (+
      {price}
      )
    </span>
  );
};

export { ServicePrice };
